import { get, pick, set } from "lodash";
import { FormSchema, JsonSchema } from "../models";

export const getEnumJsonSchemaOptions = (enumDescriptions: { [key: number]: string }) =>
  Object.keys(enumDescriptions).map((key: string) => {
    const enumKey = parseInt(key, 10);
    return { const: enumKey, title: enumDescriptions[enumKey] };
  });

export const getSchemaType = (schema: JsonSchema) => {
  return schema.type === "array" && schema.items ? (schema.items as JsonSchema).type : schema.type;
};

export const pickFormSchemaProperties = (
  formSchema: FormSchema,
  propertiesToOmit: string[],
  jsonSchemaPropertiesPath: string = "jsonSchema.properties",
  jsonSchemaRequiredPath: string = "jsonSchema.required",
  uiSchemaPath: string = "uiSchema",
) => {
  const properties = get(formSchema, jsonSchemaPropertiesPath);
  const required: string[] | undefined = get(formSchema, jsonSchemaRequiredPath);

  const nextPropertiesKeys = Object.keys(properties).filter(prop => propertiesToOmit.indexOf(prop) === -1);

  // Set properties with omittances...
  set(formSchema, jsonSchemaPropertiesPath, pick(properties, nextPropertiesKeys) as any);

  // Also, remove properties from required field that are omitted...
  if (required) {
    set(
      formSchema,
      jsonSchemaRequiredPath,
      required.filter(prop => nextPropertiesKeys.indexOf(prop) !== -1),
    );
  }

  // Note: No need to remove uiSchema properties for omitted properties as it will be ignored by
  // rjsf library if they are not on the jsonSchema. Furthermore, if dependencies are used,
  // dependent properties are not found on the jsonSchemaPropertiesPath, and would have been removed
  // from uiSchema as side effect, which we do not want.

  return formSchema;
};
